import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';

export default function RegisterPage() {
  const [step, setStep] = useState(1);
  const [userId, setUserId] = useState(null);
  const [form, setForm] = useState({ hotelName: '', name: '', email: '', phone: '', password: '' });
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [resendTimer, setResendTimer] = useState(0);
  const [kvkkAccepted, setKvkkAccepted] = useState(false);

  useEffect(() => {
    if (resendTimer > 0) {
      const t = setTimeout(() => setResendTimer(r => r - 1), 1000);
      return () => clearTimeout(t);
    }
  }, [resendTimer]);

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await api.post('/auth/register', form);
      setUserId(data.userId);
      setStep(2);
      setResendTimer(60);
    } catch (err) {
      setError(err.error || err.errors?.[0]?.msg || 'Kayıt başarısız. Lütfen tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyEmail = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/verify-email', { userId, code });
      setCode('');
      setStep(3);
      setResendTimer(60);
    } catch (err) {
      setError(err.error || 'Kod doğrulanamadı');
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyPhone = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await api.post('/auth/verify-phone', { userId, code });
      localStorage.setItem('token', data.token);
      window.location.href = '/';
    } catch (err) {
      setError(err.error || 'Kod doğrulanamadı');
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    if (resendTimer > 0) return;
    setError('');
    try {
      await api.post('/auth/resend-code', { userId, type: step === 2 ? 'email' : 'phone' });
      setResendTimer(60);
      toast.success('Yeni kod gönderildi');
    } catch (err) {
      setError(err.error || 'Kod gönderilemedi');
    }
  };

  const inputStyle = {
    width: '100%', padding: '10px 14px', borderRadius: 8,
    border: '1.5px solid #e2e8f0', fontSize: 14, outline: 'none',
    boxSizing: 'border-box', fontFamily: 'inherit',
  };
  const labelStyle = { fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 5 };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8fafc', padding: '20px 16px' }}>
      <div style={{ width: '100%', maxWidth: 440, background: '#fff', borderRadius: 16, padding: '36px 40px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: 26, fontWeight: 900, color: '#6366f1', letterSpacing: '-0.5px' }}>Reseptio</div>
          <p style={{ color: '#64748b', fontSize: 13, marginTop: 4 }}>7 günlük ücretsiz deneme — kredi kartı gerekmez</p>
        </div>

        {/* Adım göstergesi */}
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 28, gap: 0 }}>
          {['Bilgiler', 'E-posta', 'Telefon'].map((label, i) => {
            const num = i + 1;
            const active = step === num;
            const done = step > num;
            return (
              <div key={label} style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 'none' }}>
                  <div style={{
                    width: 28, height: 28, borderRadius: '50%', fontSize: 12, fontWeight: 700,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    background: done ? '#6366f1' : active ? '#6366f1' : '#e2e8f0',
                    color: (active || done) ? '#fff' : '#94a3b8',
                    transition: 'all 0.2s',
                  }}>
                    {done ? '✓' : num}
                  </div>
                  <div style={{ fontSize: 10, marginTop: 4, color: active ? '#6366f1' : '#94a3b8', fontWeight: active ? 700 : 400 }}>
                    {label}
                  </div>
                </div>
                {i < 2 && (
                  <div style={{ flex: 1, height: 2, background: done ? '#6366f1' : '#e2e8f0', margin: '0 4px', marginBottom: 16, transition: 'all 0.2s' }} />
                )}
              </div>
            );
          })}
        </div>

        {/* ── Adım 1: Bilgiler ── */}
        {step === 1 && (
          <form onSubmit={handleRegister} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div>
              <label style={labelStyle}>Otel Adı</label>
              <input style={inputStyle} value={form.hotelName} onChange={e => setForm({ ...form, hotelName: e.target.value })} placeholder="Örn: Deniz Butik Otel" required />
            </div>
            <div>
              <label style={labelStyle}>Adınız Soyadınız</label>
              <input style={inputStyle} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Ad Soyad" required />
            </div>
            <div>
              <label style={labelStyle}>E-posta</label>
              <input style={inputStyle} type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="ornek@otel.com" required />
            </div>
            <div>
              <label style={labelStyle}>Cep Telefonu</label>
              <input style={inputStyle} type="tel" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="0532 123 45 67" required />
              <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>SMS doğrulaması için gerekli</div>
            </div>
            <div>
              <label style={labelStyle}>Şifre</label>
              <input style={inputStyle} type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} placeholder="En az 6 karakter" required minLength={6} />
            </div>

            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginTop: 2 }}>
              <input type="checkbox" id="kvkk" checked={kvkkAccepted} onChange={e => setKvkkAccepted(e.target.checked)} style={{ marginTop: 3, flexShrink: 0, cursor: 'pointer' }} />
              <label htmlFor="kvkk" style={{ fontSize: 12, color: '#64748b', cursor: 'pointer', lineHeight: 1.5 }}>
                <a href="/kvkk" target="_blank" rel="noreferrer" style={{ color: '#6366f1' }}>KVKK Aydınlatma Metni</a>'ni ve{' '}
                <a href="/kullanim-kosullari" target="_blank" rel="noreferrer" style={{ color: '#6366f1' }}>Kullanım Koşulları</a>'nı okudum, kabul ediyorum.
              </label>
            </div>

            {error && <div style={{ fontSize: 13, color: '#dc2626', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, padding: '10px 14px' }}>{error}</div>}

            <button type="submit" disabled={loading || !kvkkAccepted} style={{
              width: '100%', padding: '12px 16px', borderRadius: 8, border: 'none',
              background: (loading || !kvkkAccepted) ? '#c7d2fe' : '#6366f1', color: '#fff',
              fontSize: 14, fontWeight: 700, cursor: (loading || !kvkkAccepted) ? 'not-allowed' : 'pointer',
              marginTop: 4,
            }}>
              {loading ? 'Kayıt yapılıyor...' : 'Devam Et →'}
            </button>
          </form>
        )}

        {/* ── Adım 2: E-posta doğrulama ── */}
        {step === 2 && (
          <form onSubmit={handleVerifyEmail} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div style={{ background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 10, padding: '14px 16px', fontSize: 13, color: '#0369a1' }}>
              <strong>{form.email}</strong> adresine 6 haneli doğrulama kodu gönderdik. Gelen kutunuzu kontrol edin.
            </div>

            <div>
              <label style={labelStyle}>Doğrulama Kodu</label>
              <input
                style={{ ...inputStyle, fontSize: 24, fontWeight: 700, letterSpacing: 8, textAlign: 'center' }}
                value={code}
                onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                placeholder="——————"
                inputMode="numeric"
                maxLength={6}
                autoFocus
                required
              />
            </div>

            {error && <div style={{ fontSize: 13, color: '#dc2626', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, padding: '10px 14px' }}>{error}</div>}

            <button type="submit" disabled={loading || code.length !== 6} style={{
              width: '100%', padding: '12px 16px', borderRadius: 8, border: 'none',
              background: (loading || code.length !== 6) ? '#c7d2fe' : '#6366f1', color: '#fff',
              fontSize: 14, fontWeight: 700, cursor: 'pointer',
            }}>
              {loading ? 'Doğrulanıyor...' : 'Kodu Onayla'}
            </button>

            <button type="button" onClick={handleResend} disabled={resendTimer > 0} style={{
              background: 'none', border: 'none', color: resendTimer > 0 ? '#94a3b8' : '#6366f1',
              fontSize: 13, cursor: resendTimer > 0 ? 'default' : 'pointer', padding: 0, textAlign: 'center',
            }}>
              {resendTimer > 0 ? `Kodu tekrar gönder (${resendTimer}s)` : 'Kodu tekrar gönder'}
            </button>
          </form>
        )}

        {/* ── Adım 3: Telefon doğrulama ── */}
        {step === 3 && (
          <form onSubmit={handleVerifyPhone} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 10, padding: '14px 16px', fontSize: 13, color: '#166534' }}>
              E-posta doğrulandı! Şimdi <strong>{form.phone}</strong> numarasına SMS gönderdik.
            </div>

            <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 10, padding: '12px 14px', fontSize: 12, color: '#92400e' }}>
              ⚠️ SMS gönderimi şu an test modundadır. Kodu backend konsolunda (terminal) görebilirsiniz.
            </div>

            <div>
              <label style={labelStyle}>SMS Kodu</label>
              <input
                style={{ ...inputStyle, fontSize: 24, fontWeight: 700, letterSpacing: 8, textAlign: 'center' }}
                value={code}
                onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                placeholder="——————"
                inputMode="numeric"
                maxLength={6}
                autoFocus
                required
              />
            </div>

            {error && <div style={{ fontSize: 13, color: '#dc2626', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, padding: '10px 14px' }}>{error}</div>}

            <button type="submit" disabled={loading || code.length !== 6} style={{
              width: '100%', padding: '12px 16px', borderRadius: 8, border: 'none',
              background: (loading || code.length !== 6) ? '#c7d2fe' : '#6366f1', color: '#fff',
              fontSize: 14, fontWeight: 700, cursor: 'pointer',
            }}>
              {loading ? 'Doğrulanıyor...' : 'Hesabı Aktifleştir'}
            </button>

            <button type="button" onClick={handleResend} disabled={resendTimer > 0} style={{
              background: 'none', border: 'none', color: resendTimer > 0 ? '#94a3b8' : '#6366f1',
              fontSize: 13, cursor: resendTimer > 0 ? 'default' : 'pointer', padding: 0, textAlign: 'center',
            }}>
              {resendTimer > 0 ? `SMS tekrar gönder (${resendTimer}s)` : 'SMS tekrar gönder'}
            </button>
          </form>
        )}

        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: '#64748b' }}>
          Zaten hesabın var mı? <Link to="/login" style={{ color: '#6366f1', fontWeight: 600 }}>Giriş Yap</Link>
        </p>
      </div>
    </div>
  );
}
